import type { ResourcesConfig } from 'aws-amplify';

const appOrigin = globalThis.location.origin;
const appBasePath = import.meta.env.BASE_URL.replace(/\/$/, '');
const oauthRedirectPath = '/redirecting';
const oauthRedirectSignIn =
  import.meta.env.VITE_CONNECT_OAUTH_REDIRECT_SIGN_IN ??
  `${appOrigin}${appBasePath}${oauthRedirectPath}`;
const oauthRedirectSignOut =
  import.meta.env.VITE_CONNECT_OAUTH_REDIRECT_SIGN_OUT ??
  `${appOrigin}${appBasePath || '/'}`;
const cognitoDomain = import.meta.env.VITE_CONNECT_COGNITO_DOMAIN?.replace(
  /^https?:\/\//,
  '',
);

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_CONNECT_COGNITO_CLIENT_ID,
      userPoolId: import.meta.env.VITE_CONNECT_COGNITO_USER_POOL_ID,
      identityPoolId: import.meta.env.VITE_CONNECT_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn: [oauthRedirectSignIn],
          redirectSignOut: [oauthRedirectSignOut],
          responseType: 'code',
        },
        email: true,
      },
    },
  },
};
